export const setUIVisibility = (componentSelectors = [], hide = true) => {
	componentSelectors &&
		Array.isArray(componentSelectors) &&
		componentSelectors
			.map((elem) => document.querySelector(elem))
			.filter((e) => e)
			.map((elem) => {
				hide
					? elem.classList.add('d-none')
					: elem.classList.remove('d-none');
			});
};
